<template>
  <section class="home-unificada">
    <div class="page-shell">
      <!-- HERO -->
      <section class="hero-section">
        <div class="hero-top">
          <img
            :src="logoFondoBlanco"
            alt="Valladolid Caja Financiera"
            class="hero-logo-real"
          />
        </div>

        <div class="hero-name">
          ¡HOLA <span>{{ nombreHero }}</span
          >!
        </div>

        <div class="hero-copy">Tu crédito te está esperando</div>

        <div class="hero-offer-title">Hasta</div>
        <div class="hero-offer-amount">{{ montoOfertaHero }}</div>
        <div class="hero-offer-subtitle">disponibles para ti</div>
      </section>

      <!-- SIMULADOR -->
      <section class="simulator-section">
        <div class="sim-title">¿Cuánto necesitas?</div>

        <div class="slider-wrap">
          <v-slider
            v-model="montoInput"
            step="100"
            :min="montoMinimo"
            :max="credito.monto.max"
            color="#97c400"
            track-color="#d9d9d9"
            hide-details
            class="slider-monto"
            @end="endChange"
          />
          <div class="slider-labels">
            <span>{{ montoEnteroMoneda(montoMinimo) }}</span>
            <span>{{ montoEnteroMoneda(credito.monto.max) }}</span>
          </div>
        </div>

        <div class="monto-row">
          <button type="button" class="round-btn" @click="disminuirMonto">
            <v-icon color="white" size="20">mdi-minus-circle-outline</v-icon>
          </button>

          <div class="monto-box">
            <div class="monto-box-value">
              {{ montoEnteroMoneda(montoInput) }}
            </div>
            <div class="monto-box-line"></div>
          </div>

          <button type="button" class="round-btn" @click="aumentarMonto">
            <v-icon color="white" size="20">mdi-plus-circle-outline</v-icon>
          </button>
        </div>

        <div
          v-if="esMontoInputInvalido || esMontoSujetoAprobar"
          class="monto-alerta"
          :class="{
            'monto-alerta-error': esMontoInputInvalido,
            'monto-alerta-warning': esMontoSujetoAprobar,
          }"
        >
          {{ montoInputError }}
        </div>

        <div class="plazo-title">Elige en cuantos meses quieres pagarlo</div>

        <div class="plazos-grid">
          <button
            v-for="plazo in plazosUnicos"
            :key="plazo.val"
            type="button"
            class="plazo-chip"
            :class="{ activo: plazoSeleccionado === plazo.val }"
            @click="plazoSeleccionado = plazo.val"
          >
            {{ plazo.val }}
          </button>
        </div>

        <div class="pago-title">Tu pago mensual:</div>

        <div class="pago-amount">
          <template v-if="!cargando">
            {{ montoMoneda(credito.montoPago.val) }}
          </template>
          <v-progress-circular
            v-else
            indeterminate
            color="primary"
            :width="3"
            size="28"
          />
        </div>

        <div class="pago-note">* Sin penalizaciones por pagos anticipados</div>

        <div class="icons-row">
          <div class="icon-item">
            <v-icon size="24" color="#334a67">
              mdi-card-account-details-outline
            </v-icon>
            <div class="icon-text">Sólo con</div>
            <div class="icon-text">tu INE</div>
          </div>

          <div class="icon-item">
            <v-icon size="24" color="#334a67">mdi-cash-multiple</v-icon>
            <div class="icon-text">Sin aval</div>
          </div>

          <div class="icon-item">
            <v-icon size="24" color="#334a67">mdi-shield-check-outline</v-icon>
            <div class="icon-text">Sin comprobar</div>
            <div class="icon-text">ingresos</div>
          </div>
        </div>

        <div class="mini-24-wrap">
          <img
            :src="img24hrs"
            alt="En menos de 24 horas"
            class="mini-24-image"
          />
        </div>

        <div class="cta-wrap">
          <v-btn
            rounded
            large
            color="#ff5a1f"
            class="cta-btn"
            depressed
            :disabled="
              esMontoInputInvalido ||
              credito.monto.val < montoMinimo ||
              credito.monto.val > credito.monto.max
            "
            @click="abrirDialogoInicio"
          >
            ¡Quiero mi crédito!
          </v-btn>
        </div>

        <div class="cta-note">Oferta válida por tiempo limitado</div>
      </section>

      <!-- FOOTER -->
      <section class="footer-figma">
        <img
          :src="logoBW"
          alt="Valladolid Caja Financiera"
          class="footer-logo-real"
        />

        <div class="footer-hashtag">#SOMOSLACAJAQUEVACONTIGO</div>

        <div class="footer-contact">
          Acatita de bajan 222, Morelia, Mich.<br />
          Tel. 800 3000 268<br />
          atencionasocios@valladolidcaja.com
        </div>

        <div class="footer-social">
          <a
            href="https://www.instagram.com/valladolidcaja/"
            target="_blank"
            class="social-circle"
          >
            <v-icon color="white" size="16">mdi-instagram</v-icon>
          </a>
          <a
            href="https://www.facebook.com/ValladolidCaja/"
            target="_blank"
            class="social-circle"
          >
            <v-icon color="white" size="16">mdi-facebook</v-icon>
          </a>
          <a
            href="https://www.youtube.com/channel/UCB-nXchsFrP2NzCfdkNBSjw"
            target="_blank"
            class="social-circle"
          >
            <v-icon color="white" size="16">mdi-youtube</v-icon>
          </a>
          <a
            href="https://x.com/ValladolidCaja"
            target="_blank"
            class="social-circle"
          >
            <v-icon color="white" size="16">mdi-close</v-icon>
          </a>
        </div>

        <div class="footer-links">
          Consulta términos y condiciones<br />
          en <b>www.valladolidcaja.com</b>
        </div>

        <div class="footer-legal">
          Valladolid Caja Financiera pertenece a<br />
          Caja Morelia Valladolid S.C. de A.P. de R.L. de C.V.
        </div>
      </section>
    </div>

    <!-- DIALOGO -->
    <v-dialog v-model="dialogDocumentos" width="500">
      <v-card class="ma-0 pa-0 modal-inicio">
        <v-card-title class="modal-inicio__title">
          Antes de comenzar...
        </v-card-title>

        <v-card-subtitle class="modal-inicio__subtitle text-center">
          Te enviaremos un código de verificación a tu celular
          <v-chip color="green" outlined class="mx-1">
            {{ celularOfertaMostrado }}
          </v-chip>
          por <strong>WhatsApp o mensaje SMS</strong>.
        </v-card-subtitle>

        <v-card-subtitle class="modal-inicio__subtitle text-center pt-0">
          Ten a la mano esta información para continuar con tu solicitud:
        </v-card-subtitle>

        <v-list disabled class="ma-0 px-3 pb-2 modal-inicio__list">
          <v-list-item-group color="primary">
            <v-list-item
              v-for="(item, i) in documentosNecesariosDialogo"
              :key="i"
              class="modal-inicio__item my-2"
              v-bind:class="{ 'v-list-item__title': false }"
            >
              <v-list-item-icon class="mr-3">
                <v-icon color="primary">mdi-check-circle</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold modal-inicio__item-text"
                >
                  {{ item.texto }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-card-actions class="d-flex flex-row justify-end px-4 pb-4">
          <v-btn
            @click="continuarAVerificacionOtp"
            :loading="cargando"
            :disabled="cargando"
            elevation="2"
            color="primary"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import Credito from '@/servicios/credito'
import OtpService from '@/servicios/otp'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import {
  ALERTA_ERROR,
  ID_PRODUCTO_CREDITO_ENLAZAMAS,
  ID_PRODUCTO_CREDITO_SP,
  ID_PRODUCTO_CREDITO_SPLUS,
  plazosValidos,
} from '@/utilidades/utilidades'
import { FormatoMonedaMixin } from '@/mixins/formateos/FormatoMoneda.mixin'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import { ObtieneOfertaDigitalMixin } from '@/mixins/credito/ObtieneOfertaDigital.mixin'

import logoFondoBlanco from '@/assets/images/logoFondoBlanco.png'
import logoBW from '@/assets/images/LogoB&W.png'
import sslImg from '@/assets/images/SSL.png'
import img24hrs from '@/assets/images/Logo24hrs.png'

export default {
  name: 'HomeOfertaUnificada',
  mixins: [FormatoMonedaMixin, InsertaLogMixin, ObtieneOfertaDigitalMixin],
  data: () => ({
    dialogDocumentos: false,
    documentosNecesarios: [],
    persona: {
      nombreBienvenida: '',
    },
    tipoPersona: 1,
    cargando: false,
    celularOferta: '',
    monto_oferta: 0,

    plazoSeleccionado: 0,
    montoMinimo: 1000,
    frecuencia: {
      label: '',
      valores: [],
    },
    plazos: [],
    credito: {
      monto: {
        val: 0,
        max: 0,
      },
      montoPago: {
        val: 0,
      },
      tasa: {
        val: 0,
      },
      frecuenciaSeleccionada: {
        val: '',
      },
      plazo: {
        val: 0,
        mask: ' meses',
      },
    },
    montoInput: 0,
    esMontoInputInvalido: false,
    esMontoSujetoAprobar: false,
    montoInputError: '',
    editable: false,
    montoPreutorizado: 0,
    elementosOcultos: [],
    logoFondoBlanco,
    logoBW,
    sslImg,
    img24hrs,
  }),
  computed: {
    ...mapGetters({
      obtenerPersona: 'persona/obtenerPersona',
      obtenerVigencia: 'credito/obtenerFechaVigencia',
    }),
    nombreHero() {
      const nombre = this.persona.nombreBienvenida || 'JOSÉ'
      return String(nombre).toUpperCase()
    },
    montoOfertaHero() {
      const monto = Number(
        this.montoPreutorizado ||
          (this.credito && this.credito.monto && this.credito.monto.max) ||
          0
      )

      return monto.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    },
    folioDigitalActual() {
      return this.$attrs.folioDigital || this.$route.query.folio || null
    },
    plazosUnicos() {
      const arreglo = Array.isArray(this.plazos) ? this.plazos : []
      const mapa = new Map()

      const tieneMultiplosDe6 = arreglo.some((item) => {
        const v = Number(item.val || item.plazo)
        return v > 0 && v % 6 === 0
      })

      arreglo.forEach((item) => {
        const valor = Number(item.val || item.plazo)

        const esMultiploValido = !tieneMultiplosDe6 || valor % 6 === 0

        if (valor > 0 && !mapa.has(valor) && esMultiploValido) {
          mapa.set(valor, {
            ...item,
            val: valor,
          })
        }
      })

      return Array.from(mapa.values()).sort((a, b) => a.val - b.val)
    },
    celularOfertaMostrado() {
      const celular = String(this.celularOferta || '').trim()

      if (!celular) {
        return 'tu número registrado'
      }

      return celular
    },
    documentosNecesariosDialogo() {
      return (this.documentosNecesarios || []).filter((item) => {
        const texto = String(item?.texto || '').toLowerCase()
        return !texto.includes('comprobante de domicilio')
      })
    },
  },
  created() {
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.inicializarPantalla()
  },
  mounted() {
    this.InsertaLog()
    this.ocultarChromeGlobal()
    window.scrollTo(0, 0)
  },
  beforeDestroy() {
    this.restaurarChromeGlobal()
  },
  methods: {
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),

    montoEnteroMoneda(valor) {
      return Number(valor || 0).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    },

    ocultarChromeGlobal() {
      const selectores = [
        'header',
        '.v-app-bar',
        '.v-toolbar',
        '.v-footer',
        'footer',
        '.footer',
        '.app-footer',
      ]

      this.elementosOcultos = []

      selectores.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          const estiloAnterior = el.getAttribute('style') || ''
          this.elementosOcultos.push({
            el,
            style: estiloAnterior,
          })
          el.style.display = 'none'
        })
      })
    },

    restaurarChromeGlobal() {
      this.elementosOcultos.forEach((item) => {
        if (item && item.el) {
          item.el.setAttribute('style', item.style)
        }
      })
      this.elementosOcultos = []
    },

    inicializarPantalla() {
      const personaStore = this.$store.getters['persona/obtenerPersona'] || {}
      const datosPersonales = personaStore.datosPersonales || {}

      this.persona = datosPersonales
      this.tipoPersona = personaStore.tipoPersona || 1
      this.celularOferta =
        this.$store.getters['persona/obtenerCelularOferta'] || ''
      this.documentosNecesarios =
        this.$store.getters['personaDocumentos/obtenerDocumentosASolicitar'] ||
        []

      this.editable = this.$store.getters['credito/obtenerEditable']
      this.credito =
        this.$store.getters['credito/obtenerCredito'] || this.credito
      this.frecuencia =
        this.$store.getters['credito/obtenerFrecuencias'] || this.frecuencia

      if (
        this.credito &&
        this.credito.tipoCredito == ID_PRODUCTO_CREDITO_ENLAZAMAS
      ) {
        this.frecuencia.label = 'Tu retención será de manera:'
      }

      if (
        this.credito &&
        (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SP ||
          this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS)
      ) {
        this.frecuencia.label = 'Tu frecuencia de pago es:'
      }

      this.plazoSeleccionado =
        this.credito && this.credito.plazo ? this.credito.plazo.val : 18

      this.montoInput =
        this.credito && this.credito.monto ? this.credito.monto.val : 5000

      if (
        this.credito &&
        this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS
      ) {
        this.plazos = plazosValidos(
          this.montoInput,
          this.$store.getters['credito/obtenerPlazos'],
          this.$store.getters['credito/obtenerRangoMontosPlazos']
        )
      } else {
        this.plazos = this.$store.getters['credito/obtenerPlazos'] || []
      }

      this.montoPreutorizado =
        this.credito && this.credito.monto ? this.credito.monto.val : 0

      this.monto_oferta =
        this.credito && this.credito.monto ? this.credito.monto.max : 80000

      if (this.folioDigitalActual) {
        this.obtieneOfertaDigital(this.folioDigitalActual)
      }
    },

    postObtieneOfertaDigital(result) {
      if (result && result.DatosGenerales && result.DatosGenerales.length > 0) {
        const datos = result.DatosGenerales[0]
        this.monto_oferta = Number(datos.Monto_Preautorizado || 0)
        this.montoPreutorizado = Number(datos.Monto_Preautorizado || 0)
      }
    },

    abrirDialogoInicio() {
      this.updateCredito()
      this.dialogDocumentos = true
      this.quitarClases()
    },

    async quitarClases() {
      try {
        setTimeout(() => {
          while (
            document.getElementsByClassName('v-list-item__title').length > 0
          ) {
            document
              .getElementsByClassName('v-list-item__title')[0]
              .classList.remove('v-list-item__title')
          }
        }, 50)
      } catch (error) {
        console.error(error)
      }
    },

    endChange() {
      this.credito.monto.val = this.montoInput
      this.updateMontoPago()
    },

    aumentarMonto() {
      const maximo =
        this.credito.monto.max || this.montoPreutorizado || this.montoInput
      const siguiente = this.montoInput + 100
      this.montoInput = siguiente > maximo ? maximo : siguiente
      this.credito.monto.val = this.montoInput
      this.updateMontoPago()
    },

    disminuirMonto() {
      const siguiente = this.montoInput - 100
      this.montoInput =
        siguiente < this.montoMinimo ? this.montoMinimo : siguiente
      this.credito.monto.val = this.montoInput
      this.updateMontoPago()
    },

    updateCredito() {
      this.credito.plazo = {
        mask: this.credito.plazo.mask,
        name: this.plazoSeleccionado + this.credito.plazo.mask,
        title: 'PLAZO',
        val: this.plazoSeleccionado,
      }

      this.$store.credito = this.credito
      this.$store.dispatch('credito/actualizarCredito', this.credito)
      this.$store.dispatch('credito/actualizarPlazos')
    },

    async updateMontoPago() {
      let result

      try {
        this.cargando = true

        if (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_SPLUS) {
          this.plazos = plazosValidos(
            this.montoInput,
            this.$store.getters['credito/obtenerPlazos'],
            this.$store.getters['credito/obtenerRangoMontosPlazos']
          )

          const existe = this.plazosUnicos.some(
            (plazo) => plazo.val == this.plazoSeleccionado
          )

          if (!existe && this.plazosUnicos.length > 0) {
            this.plazoSeleccionado =
              this.plazosUnicos[this.plazosUnicos.length - 1].val
            this.credito.plazo = {
              mask: this.credito.plazo.mask,
              name: this.plazoSeleccionado + this.credito.plazo.mask,
              title: 'PLAZO',
              val: this.plazoSeleccionado,
            }
          }
        }

        result = await Credito.obtenerPagoSimulado(this.credito)

        if (result.data.Codigo == 200) {
          this.$store.dispatch(
            'credito/actuliazarMontoPago',
            result.data.Modelo
          )
        } else {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }

        this.cargando = false
      } catch (e) {
        if (!axios.isCancel(e)) {
          this.enviarAlertaError(
            ALERTA_ERROR.mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
          this.cargando = false
        }
      }
    },

    async enviarOtp() {
      this.cargando = true
      const enviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']

      let result

      try {
        result = await OtpService.EnviarOtp(enviarOtpRequest)

        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }

        this.cargando = false
      } catch {
        this.enviarAlertaError(
          ALERTA_ERROR.mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },

    async continuarAVerificacionOtp() {
      this.updateCredito()
      await this.enviarOtp()
      this.$router.push('verificacion-otp')
    },
  },
  watch: {
    plazoSeleccionado() {
      this.updateCredito()
      this.updateMontoPago()
    },

    montoInput(value) {
      this.credito.monto.val = value

      if (value < this.montoMinimo) {
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError = 'El monto mínimo es de $' + this.montoMinimo
      } else if (value > this.credito.monto.max) {
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError =
          'El monto máximo es de $' + this.credito.monto.max
      } else if (value % 100 !== 0) {
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError = 'Elige un monto múltiplo de 100'
      } else if (value > this.montoPreutorizado) {
        this.esMontoSujetoAprobar = true
        this.esMontoInputInvalido = false
        this.montoInputError = 'Monto sujeto a aprobación'
      } else {
        this.esMontoSujetoAprobar = false
        this.esMontoInputInvalido = false
        this.credito.monto.val = this.montoInput
        this.montoInputError = ''
      }
    },
  },
}
</script>

<style scoped>
.home-unificada {
  background: #ffffff;
  min-height: 100vh;
  margin: 0 auto;
}

.page-shell {
  background: #ffffff;
  min-height: 100vh;
  margin: 0 auto;
}

/* HERO */
.hero-section {
  background: #ffffff;
  text-align: center;
  padding: 18px 24px 24px;
}

.hero-top {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 12px;
  min-height: 52px;
}

.hero-logo-real {
  width: 230px;
  max-width: 72%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.hero-ssl-real {
  position: absolute;
  top: 4px;
  right: 0;
  width: 78px;
  object-fit: contain;
  display: block;
  opacity: 0.35;
}

.hero-name {
  font-size: 34px;
  line-height: 36px;
  font-weight: 900;
  color: #111111;
  margin-bottom: 12px;
  text-transform: uppercase;
  text-shadow: 0 1px 0 #ffffff, 0 2px 0 rgba(255, 255, 255, 0.9),
    0 4px 0 rgba(0, 0, 0, 0.08), 0 6px 8px rgba(0, 0, 0, 0.18);
}

.hero-name span {
  color: #97c400;
  text-shadow: 0 1px 0 #ffffff, 0 2px 0 rgba(255, 255, 255, 0.95),
    0 4px 0 rgba(0, 0, 0, 0.08), 0 6px 8px rgba(0, 0, 0, 0.16);
}

.hero-copy {
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;
  margin-bottom: 14px;
}

.hero-offer-title {
  color: #ff5a1f;
  font-size: 34px;
  line-height: 34px;
  font-weight: 900;
  margin-bottom: 2px;
  text-shadow: 0 1px 0 #ffffff, 0 2px 0 rgba(255, 255, 255, 0.9),
    0 4px 0 rgba(0, 0, 0, 0.08), 0 6px 8px rgba(0, 0, 0, 0.18);
}

.hero-offer-amount {
  color: #ff5a1f;
  font-size: 62px;
  line-height: 60px;
  font-weight: 900;
  margin: 0 0 6px;
  text-shadow: 0 1px 0 #ffffff, 0 2px 0 rgba(255, 255, 255, 0.92),
    0 5px 0 rgba(0, 0, 0, 0.08), 0 8px 10px rgba(0, 0, 0, 0.18);
}

.hero-offer-subtitle {
  font-size: 18px;
  line-height: 21px;
  color: #1f1f1f;
}

/* SIMULADOR */
.simulator-section {
  background: #efeff3;
  text-align: center;
  padding: 30px 24px 28px;
}

.sim-title {
  font-size: 24px;
  line-height: 28px;
  font-weight: 900;
  color: #222222;
  margin-bottom: 22px;
}

.slider-wrap {
  margin-bottom: 14px;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 14px;
  color: #1f1f1f;
  font-weight: 800;
  margin-top: -2px;
}

.monto-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  margin-bottom: 22px;
}

.round-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 12px;
  background: #97c400;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.monto-box {
  width: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
}

.monto-box-value {
  font-size: 33px;
  line-height: 36px;
  font-weight: 900;
  color: #232a35;
  margin-bottom: 6px;
}

.monto-box-line {
  width: 100%;
  height: 2px;
  background: #7b7b7b;
  border-radius: 999px;
}

.monto-alerta {
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}

.monto-alerta-error {
  color: #d32f2f;
}

.monto-alerta-warning {
  color: #f57c00;
}

.plazo-title {
  font-size: 17px;
  line-height: 22px;
  color: #2a2a2a;
  font-weight: 700;
  margin-bottom: 14px;
}

.plazos-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 18px;
}

.plazo-chip {
  height: 42px;
  min-width: 48px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #b7cf86;
  background: #f7f7f7;
  color: #5b5b5b;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}

.plazo-chip.activo {
  background: #97c400;
  border-color: #97c400;
  color: white;
}

.pago-title {
  font-size: 17px;
  line-height: 20px;
  color: #2a2a2a;
  font-weight: 800;
  margin-bottom: 4px;
}

.pago-amount {
  font-size: 58px;
  line-height: 56px;
  color: #ff5a1f;
  font-weight: 900;
  margin-bottom: 6px;
  text-shadow: 0 3px 0 rgba(0, 0, 0, 0.08);
}

.pago-note {
  font-size: 11px;
  line-height: 15px;
  color: #2f2f2f;
  margin-bottom: 22px;
}

.icons-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 18px;
}

.icon-item {
  flex: 1;
  text-align: center;
}

.icon-text {
  font-size: 12px;
  line-height: 15px;
  color: #2f2f2f;
}

.mini-24-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}

.mini-24-image {
  width: 170px;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

.cta-wrap {
  display: flex;
  justify-content: center;
}

.cta-btn {
  width: 100%;
  max-width: 300px;
  text-transform: none !important;
  font-size: 20px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  color: white !important;
  height: 56px !important;
  box-shadow: none !important;
  margin-bottom: 10px;
}

.cta-note {
  font-size: 12px;
  line-height: 16px;
  color: #444444;
}

/* FOOTER */
.footer-figma {
  background: #66666b;
  text-align: center;
  padding: 24px 22px 26px;
  color: white;
  margin-top: auto;
}

.footer-logo-real {
  width: 155px;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto 14px;
}

.footer-hashtag {
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  margin-bottom: 14px;
}

.footer-contact {
  font-size: 12px;
  line-height: 19px;
  color: #f1f1f1;
  margin-bottom: 16px;
}

.footer-social {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-bottom: 16px;
}

.social-circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #97c400;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.footer-links {
  font-size: 12px;
  line-height: 18px;
  color: #f4f4f4;
  margin-bottom: 12px;
}

.footer-legal {
  font-size: 10.5px;
  line-height: 16px;
  color: #d7d7d7;
}

::v-deep .slider-monto .v-slider__track-background {
  height: 6px !important;
  border-radius: 999px;
}

::v-deep .slider-monto .v-slider__track-fill {
  height: 6px !important;
  border-radius: 999px;
}

::v-deep .slider-monto .v-slider__thumb {
  width: 20px !important;
  height: 20px !important;
  left: -10px !important;
  box-shadow: none !important;
}

::v-deep .slider-monto .v-slider__thumb::before {
  display: none !important;
}

@media (max-width: 380px) {
  .hero-logo-real {
    width: 200px;
    max-width: 70%;
  }

  .hero-ssl-real {
    width: 68px;
    top: 6px;
  }

  .hero-name {
    font-size: 30px;
    line-height: 32px;
  }

  .hero-offer-title {
    font-size: 30px;
    line-height: 30px;
  }

  .hero-offer-amount {
    font-size: 52px;
    line-height: 50px;
  }

  .monto-box {
    width: 150px;
  }

  .monto-box-value {
    font-size: 30px;
    line-height: 33px;
  }

  .pago-amount {
    font-size: 50px;
    line-height: 48px;
  }

  .mini-24-image {
    width: 155px;
  }

  .footer-logo-real {
    width: 145px;
  }
}

.modal-inicio {
  border-radius: 14px;
}

.modal-inicio__title {
  font-size: 22px;
  font-weight: 800;
  color: #2b2b2b;
  padding: 26px 28px 10px;
}

.modal-inicio__subtitle {
  font-size: 15px;
  line-height: 1.6;
  color: #5b5b5b;
  padding-left: 28px;
  padding-right: 28px;
}

.modal-inicio__list {
  padding-left: 16px;
  padding-right: 16px;
}

.modal-inicio__item {
  background: #edf6ee;
  border-radius: 10px;
  min-height: 68px;
}

.modal-inicio__item-text {
  color: #28a745;
  font-size: 15px;
  line-height: 1.4;
}
</style>
